/** The preset counts the Add to list drawers offer, before their ceiling. */
export const IMPORT_COUNT_OPTIONS = [100, 500, 1000, 2500, 5000] as const;

/** Why "All (N)" is smaller than the number of matches, when it is. */
export interface ImportCap {
  /** The most one import adds. */
  cap: number;
  /** True when only the plan's leads per list holds it, so a higher plan
   *  lifts it; false when the per-import ceiling does too (a plan whose limit
   *  equals the ceiling included), which no plan lifts. */
  byPlan: boolean;
}

/**
 * The ceiling that holds an import below the search's real match count, or
 * null when nothing does. `matches` is the provider total; an unknown or
 * absent total names no ceiling.
 */
export function importCap({
  matches,
  planLimit,
  requestCeiling,
}: {
  matches: number | undefined;
  planLimit: number | null;
  requestCeiling: number;
}): ImportCap | null {
  if (typeof matches !== 'number' || !Number.isFinite(matches) || matches <= 0)
    return null;
  const planCap = planLimit ?? Infinity;
  const cap = Math.min(planCap, requestCeiling);
  if (matches <= cap) return null;
  return { cap, byPlan: planCap < requestCeiling };
}
